import MentoringRequests from './MentoringRequests.vue';

export default MentoringRequests;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/requests/index.ts